import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  SuiBadgeComponent,
  SuiIconButtonComponent,
} from '@stride-ui/components';
import { IDiscountSectionItem } from './interfaces';

@Component({
  selector: 'tnq-discount-section',
  imports: [
    TranslateModule,
    SuiIconButtonComponent,
    SuiBadgeComponent,
    DecimalPipe,
  ],
  templateUrl: './discount-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './discount-section.component.scss',
})
export class DiscountSectionComponent {
  readonly assignedDiscounts = input<IDiscountSectionItem[]>([]);
  readonly showUsage = input<boolean>(false);
  readonly titleKey = input('customer_groups.extra_discounts');
  readonly emptyKey = input('customer_groups.no_extra_discounts');
  readonly removable = input(true);

  readonly remove = output<IDiscountSectionItem>();

  onRemove(discount: IDiscountSectionItem): void {
    this.remove.emit(discount);
  }
}
